<script lang="ts">
import { onClickOutside } from '@vueuse/core'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['changeVisibility'],
  setup() {
    return {}
  },
  mounted() {
    onClickOutside(this.$refs.memberZoneMenu, (event) => {
      const clickedElId = (event.target as HTMLElement).id
      const clickedElParentId = (event.target as HTMLElement).parentElement?.id
      if (
        ![clickedElParentId, clickedElId].includes('header-member-zone-btn')
      ) {
        this.$emit('changeVisibility', false)
      }
    })
  },
})
</script>

<template>
  <div
    class="pointer-events-none fixed left-0 top-16 hidden h-screen w-full justify-center bg-black/50 transition-all duration-200 ease-in-out lg:flex"
    :class="isVisible ? 'visible opacity-100' : 'invisible opacity-0'"
  >
    <div class="flex w-full max-w-screen-xl flex-col items-end">
      <div
        class="z-0 m-0 -mb-[1px] mr-[80px] h-0 w-0 border-10 border-t-0 border-b-pure-white border-l-transparent border-r-transparent transition-all duration-200 ease-in-out"
        :class="isVisible ? 'visible opacity-100' : 'invisible opacity-0'"
      />
      <div
        ref="memberZoneMenu"
        class="pointer-events-auto flex w-52 flex-col rounded-md bg-pure-white p-3 transition-all duration-200 ease-in-out"
        :class="isVisible ? 'visible opacity-100' : 'invisible opacity-0'"
      >
        <div class="flex flex-col gap-2">
          <RouterLink
            class="flex h-8 w-full items-center justify-start rounded-lg border-0 px-2 py-0 text-left text-sm transition-all duration-200 ease-in-out hover:bg-primary/10"
            :to="{
              name: 'members-zone',
            }"
            title="Members Zone"
            @click="$emit('changeVisibility', false)"
          >
            <AppIcon :icon="Icons.MembersZone" size="xs" class="mr-2" />
            <span class="font-bold">Members Zone</span>
          </RouterLink>
          <AppButton
            class="!m-0 !h-8 w-full !p-0 text-sm transition-all duration-200 ease-in-out hover:bg-primary/10"
            :route="{
              name: 'logout',
            }"
            title="Logout"
            icon=""
            @click="$emit('changeVisibility', false)"
          >
            {{ $t('label.logout') }}
          </AppButton>
        </div>
      </div>
    </div>
  </div>
</template>
